export default "__VITE_ASSET__6c942464__"